let Player;
let LockSeek	=	true;
let LockPreview	=	true;

$(function () {
	<%- include('source/callbacks/_common.js'); %>
	<%- include('source/_change.js'); %>

	Callbacks["redirectCart"]	=	function (data) {
		location.href	=	data.redirect;
	}

	if($("#Media").length != 0) {
		let $script	=	$('<script />');

		$script.attr("src", "https://www.youtube.com/iframe_api");
		$("head").append($script);

		$("input.type").on("change first", function (e) {
			let $target		=	$(this);
			let $parent		=	$target.closest(".step");
			let duration	=	(e.type == "first")?	0	:	400;
			
			$parent.find(".choice:not(."+ $target.val() +")").stop().fadeOut(duration, function () {
				$parent.find(".choice."+ $target.val()).stop().fadeIn(duration);
			});
		});
		
		$("input.type:checked").trigger("first");

		$(".reflection").on("click", function () {
			let $target	=	$(this).parents(".step").find("input[name="+ $(this).attr("data-target") +"]");
			let time	=	getTimestamp($target.val());

			if(Player.getCurrentTime() != time / 1000) {
				LockSeek	=	false;

				Player.playVideo();
				Player.seekTo(time / 1000, true);
			}
		});

		$(".preview").on("click", function () {
			let	start	=	getTimestamp($("input[name=start]").val());
			let end		=	getTimestamp($("input[name=end]").val());
			
			if(checkError(start, end)) {
				return;
			}
			
			if(start < 1) {
				start	=	1;
			}

			Player.loadVideoById({
				videoId			:	VideoAttribute.mediaID,
				startSeconds	:	start / 1000,
				endSeconds		:	end / 1000,
			});

			LockPreview	=	false;
		});

		$(".get").on("click", function () {
			let $target		=	$(this).parents(".step").find("input[name="+ $(this).attr("data-target") +"]");
			let time		=	Math.ceil(Player.getCurrentTime() * 1000);
			let value		=	getTime(time);
			let position	=	getTime(time, true);

			$target.val(value).trigger("change");

			$(this).parents(".step").find(".messages").html('<div class="message success">取得しました(位置：'+ position +')</div>').fadeIn(function () {
				$(this).delay(2000).fadeOut();
			});
		});

		$(".move").on("click", function () {
			let $target	=	$(".wizard .step[data-step="+ $(this).attr("data-target") +"]");
			let $flow	=	$(".flow .step[data-step="+ $(this).attr("data-target") +"]");

			$(".flow .active").removeClass("active");

			$(".wizard .step:visible").fadeOut(function () {
				$flow.addClass("active");
				$target.fadeIn();
			});
		});

		$("input[name=start], input[name=end]").on("change input blur", function () {
			let $input	=	$(this);
			
			let start		=	getTimestamp($("input[name=start]").val());
			let end			=	getTimestamp($("input[name=end]").val());
			let second		=	(end - start) / 1000;
			let subtotal	=	parseInt(VideoAttribute.price);
			let charge		=	VideoAttribute.unit * Math.ceil(second);
			let total		=	subtotal + charge;
			
			checkError(start, end);

			if(second <= 0 || start < 0 || end > getTimestamp(VideoAttribute.time)) {
				second		=	"-";
				subtotal	=	"-";
				charge		=	"-";
				total		=	"-";
			}

			$("[data-replace=start]").text(getTime(start, true));
			$("[data-replace=end]").text(getTime(end, true));

			$(".costs [data-replace=second]").text(Common.comma(second));
			$(".costs [data-replace=subtotal]").text(Common.comma(subtotal));
			$(".costs [data-replace=charge]").text(Common.comma(charge));
			$(".costs [data-replace=total]").text(Common.comma(total));

			$("input[name=price]").val(parseInt(total) || 0);
		}).trigger("change");

		$("#Contents form.change").on("submit", change);

		function checkError(start, end) {
			$(".step:visible").find("[data-replace=messageStep1], [data-replace=messageStep2], [data-replace=messageStep3]").stop().fadeOut();

			if(start < 0) {
				$(".step:visible").find("[data-replace=messageStep1], [data-replace=messageStep3]").html('<div class="message error">開始位置は0秒以上にしてください</div>').stop().fadeIn();

				return true;
			}
			else if(start > getTimestamp(VideoAttribute.time)) {
				$(".step:visible").find("[data-replace=messageStep1], [data-replace=messageStep3]").html('<div class="message error">開始位置は'+ getTime(getTimestamp(VideoAttribute.time), true) +'以下にしてください</div>').stop().fadeIn();

				return true;
			}
			
			if(end < 0) {
				$(".step:visible").find("[data-replace=messageStep2], [data-replace=messageStep3]").html('<div class="message error">終了位置は0秒以上にしてください</div>').stop().fadeIn();

				return true;
			}
			else if(end > getTimestamp(VideoAttribute.time)) {
				$(".step:visible").find("[data-replace=messageStep2], [data-replace=messageStep3]").html('<div class="message error">終了位置は'+ getTime(getTimestamp(VideoAttribute.time), true) +'以下にしてください</div>').stop().fadeIn();

				return true;
			}

			if(start >= end) {
				$(".step:visible").find("[data-replace=messageStep3]").html('<div class="message error">終了位置は開始位置よりも大きくしてください</div>').stop().fadeIn();

				return true;
			}

			$("[data-replace=messageStep1], [data-replace=messageStep2], [data-replace=messageStep3]").hide();
		}

		function getTime(value, flag, noMilli) {
			let result		=	"";
			let hour		=	Math.floor(value / 3600000);
			let minute		=	Math.floor((value - (hour * 3600000)) / 60000);
			let second		=	Math.floor((value - (hour * 3600000) - (minute * 60000)) / 1000);
			let millisecond	=	Math.floor((value - (hour * 3600000) - (minute * 60000) - (second * 1000)));

			if(!flag || hour > 0) {
				result	+=	getPadding(hour, 2) +((flag)? "時間" : ":");
			}

			if(!flag || result != "" || minute > 0) {
				result	+=	getPadding(minute, 2) +((flag)? "分" : ":");
			}

			result	+=	getPadding(second, 2) +((flag)? "秒" : ".");

			if(!noMilli && (!flag || millisecond > 0)) {
				result	+=	getPadding(millisecond, 3);
			}

			return result;
		}

		function getTimestamp(value) {
			if(value.search(/^\d{1,2}:\d{1,2}:\d{1,2}.\d{1,3}$/) == -1) {
				return 0;
			}

			return new Date("1970-01-01T"+ value +"+0000").getTime();
		}

		function getPadding(value, length){
			let prefix	=	"";
			
			for(let i = 0; i < length; i++) {
				prefix	+=	"0";
			}

			return (prefix +""+ value).slice(-length);
		}
	}
});

function onYouTubeIframeAPIReady() {
	Player	=	new YT.Player(
		'Player', {
			height		:	'auto',
			width		:	'auto',
			videoId		:	VideoAttribute.mediaID,
			playerVars	:	{
				playsinline	: 	1,
			},
			events		:	{
				onStateChange	:	function (e) {
					if(!LockPreview && e.data == 0) {
						LockPreview	=	true;
						LockSeek	=	false;

						Player.seekTo(Player.getCurrentTime(), true);
					}

					if(!LockSeek && e.data == 1) {
						LockSeek	=	true;
						
						Player.seekTo(Player.getCurrentTime(), true);
						Player.pauseVideo();
					}
				}
			}
		}
	);
}